const BASEURL = process.env.REACT_APP_BACKEND;

const setBaseUrlPrefix = (path) => {
  return BASEURL.concat(path);
};

const apiPathConstants = {
  auth: {
    scannerSession: setBaseUrlPrefix("/auth/verify-scanner"),
    scannerLogin: setBaseUrlPrefix("/scanner/login"),
    scannerRegister: setBaseUrlPrefix("/auth/scanner-register"),
    googleLogin: setBaseUrlPrefix("/google"),
    facebookLogin: setBaseUrlPrefix("/facebook"),
    login: setBaseUrlPrefix("/auth/login"),
    logout: setBaseUrlPrefix("/auth/logout"),
    register: setBaseUrlPrefix("/auth/register"),
    verifySession: setBaseUrlPrefix("/auth/verify-session"),
    verifyEmail: setBaseUrlPrefix("/auth/verify-email"),
    sendEmail: setBaseUrlPrefix("/auth/send/verification-email"),
    forgetPassword: setBaseUrlPrefix("/auth/forgot-password"),
    updateProfile: setBaseUrlPrefix("/auth/customer"),
    resetPasswordToken: setBaseUrlPrefix("/auth/reset-password"),
    changePassword: setBaseUrlPrefix("/auth/change-password"),
  },
  follow: {
    addFollower: setBaseUrlPrefix("/follow/add-follower"),
    deleteFollower: setBaseUrlPrefix("/follow/delete-follower"),
    listFollowers: setBaseUrlPrefix("/follow/followers"),
  },
  booking: {
    getCustomerBooking: setBaseUrlPrefix("/bookings/allBookingCustomer"),
    getAttachment: setBaseUrlPrefix("/bookings/attachment"),
    ticketPage: setBaseUrlPrefix("/bookings/ticketPage"),
    resendTicket: setBaseUrlPrefix("/bookings/resend-ticket"),
    getQrCode: setBaseUrlPrefix("/bookings/qrCode"),
    verifyQrCode: setBaseUrlPrefix("/bookings/verifyQrCode"),
    scannerVerifyQrCode: setBaseUrlPrefix("/bookings/scannerVerifyQrCode"),
    previewQrCode: setBaseUrlPrefix("/bookings/scanner/previewQrCode"),
    confirmScan: setBaseUrlPrefix("/bookings/scanner/confirmScan"),
  },
  language: {
    getLanguageList: setBaseUrlPrefix("/feature/languages"),
    addLanguage: setBaseUrlPrefix("/feature/addLanguage"),
    updateLanguage: setBaseUrlPrefix("/feature/updateLanguage"),
    deleteLanguage: setBaseUrlPrefix("/feature/deleteLanguage"),
  },
  pageHeadings: {
    getPageHeadings: setBaseUrlPrefix("/feature/pageheading"),
    addPageHeadings: setBaseUrlPrefix("/feature/addPageheading"),
    updatePageHeadings: setBaseUrlPrefix("/feature/updatePageheading"),
  },
  event: {
    getEventList: setBaseUrlPrefix("/org/getEvent"),
    eventList: setBaseUrlPrefix("/org/listEvent"),
    getEventImage: setBaseUrlPrefix("/org/getEventImages"),
    updateEvent: setBaseUrlPrefix("/org/updateEvent"),
    updateStatus: setBaseUrlPrefix("/org/updateStatus"),
    deleteEvent: setBaseUrlPrefix("/org/deleteEvent"),
  },
  eventTickets: {
    addEventTicket: setBaseUrlPrefix("/org/addTicket"),
    updateEventTicket: setBaseUrlPrefix("/org/updateTicket"),
    ticketList: setBaseUrlPrefix("/org/getTicketList"),
    ticketListOrg: setBaseUrlPrefix("/org/getTicketListOrg"),
    ticketListAdmin: setBaseUrlPrefix("/org/getTicketListAdmin"),
    deleteTicket: setBaseUrlPrefix("/org/deleteTicket"),
  },
  movieTickets: {
    ticketList: setBaseUrlPrefix("/org/getMovieTicket"),
    ticketListAdmin: setBaseUrlPrefix("/org/getMovieTicketAdmin"),
    ticketListPublic: setBaseUrlPrefix("/org/getMovieTicketPublic"),
    tickets: setBaseUrlPrefix("/org/getMovieTicket"),
    addMovieTicket: setBaseUrlPrefix("/org/addMovieTicket"),
    updateMovieTicket: setBaseUrlPrefix("/org/updateMovieTicket"),
    deleteMovieTicket: setBaseUrlPrefix("/org/deleteMovieTicket"),
  },
  movie: {
    movieId: setBaseUrlPrefix("/admin/movieData"),
    addMovie: setBaseUrlPrefix("/org/addMovie"),
    addAdminMovie: setBaseUrlPrefix("/org/addAdminMovie"),
    updateMovieStatus: setBaseUrlPrefix("/org/updateMovieStatus"),
    addTheater: setBaseUrlPrefix("/org/addTheatre"),
    getTheaters: setBaseUrlPrefix("/org/listTheaters"),
    updateMovie: setBaseUrlPrefix("/org/updateMovie"),
    deleteMovie: setBaseUrlPrefix("/org/deleteMovie"),
    deleteTheatre: setBaseUrlPrefix("/org/deleteTheatre"),
  },
  eventManagement: {
    getEventList: setBaseUrlPrefix("/admin/eventList"),
  },
  movieAdmin: {
    getMovieList: setBaseUrlPrefix("/admin/moviesList"),
  },
  blogCategories: {
    getBlogCategoriesList: setBaseUrlPrefix("/blog/blogCategoryList"),
    addBlogCategory: setBaseUrlPrefix("/blog/addBlogCategory"),
    updateBlogCategory: setBaseUrlPrefix("/blog/updateBlogCategory"),
    deleteBlogCategory: setBaseUrlPrefix("/blog/deleteBlogCategory"),
  },
  blog: {
    getBlogList: setBaseUrlPrefix("/blog/blogList"),
    addBlog: setBaseUrlPrefix("/blog/addBlog"),
    updateBlog: setBaseUrlPrefix("/blog/updateBlog"),
    deleteBlog: setBaseUrlPrefix("/blog/deleteBlog"),
  },
  faq: {
    getFaqList: setBaseUrlPrefix("/faq/faqList"),
    addFaq: setBaseUrlPrefix("/faq/addFaq"),
    updateFaq: setBaseUrlPrefix("/faq/updateFaq"),
    deleteFaq: setBaseUrlPrefix("/faq/deleteFaq"),
  },
  header: {
    getHeader: setBaseUrlPrefix("/feature/getHeader"),
    addHeader: setBaseUrlPrefix("/feature/addHeader"),
    deleteHeader: setBaseUrlPrefix("/feature/deleteHeader"),
  },
  aboutUs: {
    getAboutUs: setBaseUrlPrefix("/feature/aboutUs"),
    addAboutUs: setBaseUrlPrefix("/feature/addAboutUs"),
    updateAboutUs: setBaseUrlPrefix("/feature/updateAboutUs"),
    deleteAboutUs: setBaseUrlPrefix("/feature/deleteAboutUs"),
  },
  testimonialSection: {
    getTestimonial: setBaseUrlPrefix("/feature/testimonialSection"),
    addTestimonial: setBaseUrlPrefix("/feature/addTestimonialSection"),
    updateTestimonial: setBaseUrlPrefix("/feature/updateTestimonialSection"),
    deleteTestimonial: setBaseUrlPrefix("/feature/deleteTestimonialSection"),
  },
  transactions: {
    getOrgTransactions: setBaseUrlPrefix("/transaction/getOrgTransactions"),
    getAdminTransactions: setBaseUrlPrefix("/transaction/transactions"),
  },
  coupons: {
    getEventCoupon: setBaseUrlPrefix("/feature/coupons"),
    getCoupons: setBaseUrlPrefix("/feature/couponList"),
    getAllEventsMovies: setBaseUrlPrefix("/admin/allEventsAndMovies"),
    getCouponByCode: setBaseUrlPrefix("/feature/coupon"),
    addCoupon: setBaseUrlPrefix("/coupon/create-coupon-admin"),
    editCoupon: setBaseUrlPrefix("/coupon/edit-coupon-admin"),
    deleteCoupon: setBaseUrlPrefix("/coupon/delete-coupon-admin"),
    adminCouponsList: setBaseUrlPrefix("/coupon/admin-coupons"),
  },
  offers: {
    getOffers: setBaseUrlPrefix("/public/offers"),
  },
  emailTemplates: {
    listTemplates: setBaseUrlPrefix("/feature/emailTemplates"),
    updateTemplates: setBaseUrlPrefix("/feature/updateEmailTemplate"),
  },
  withDrawal: {
    connectAccount: setBaseUrlPrefix("/transaction/connectAccountLink"),
    checkStatus: setBaseUrlPrefix("/transaction/checkStatus"),
    requestWithdrawal: setBaseUrlPrefix("/transaction/requestWithdrawal"),
    withdrawalList: setBaseUrlPrefix("/transaction/withdrawals"),
    updateStatus: setBaseUrlPrefix("/transaction/updateWithdrawal"),
  },
  contactUs: {
    mailToAdmin: setBaseUrlPrefix("/feature/mailToAdmin"),
    addSubscriber: setBaseUrlPrefix("/feature/addSubscriber"),
  },
  seatsIO: {
    addChartKey: setBaseUrlPrefix("/org/createChart"),
    addEventKey: setBaseUrlPrefix("/org/createEvent"),
    listChartKeys: setBaseUrlPrefix("/org/listChart"),
    listEventKeys: setBaseUrlPrefix("/org/listEvent"),
    addAdminChartKey: setBaseUrlPrefix("/org/createAdminChart"),
    addAdminEventKey: setBaseUrlPrefix("/org/createAdminEvent"),
    listAdminChartKeys: setBaseUrlPrefix("/org/listAdminChart"),
    listAdminEventKeys: setBaseUrlPrefix("/org/listAdminEvent"),
  },
  scanner: {
    verifySession: setBaseUrlPrefix("/scanner/verify-session"),
    login: setBaseUrlPrefix("/scanner/login"),
    register: setBaseUrlPrefix("/scanner/register"),
    activateScanner: setBaseUrlPrefix("/scanner/activate"),
    resendScannerActivation: setBaseUrlPrefix(
      "/organizer/scanners/resend-activation"
    ),
    verifyTicket: setBaseUrlPrefix("/scanner/verify-ticket"),
    confirmTicket: setBaseUrlPrefix("/scanner/confirm-ticket"),
    eventList: setBaseUrlPrefix("/scanner/allowed-events"),
    listBookingsForEvent: (eventId) =>
      setBaseUrlPrefix(`/scanner/event-bookings/${eventId}`),
  },
  organizerSponsor: {
    getSponsorList: setBaseUrlPrefix("/sponsor/sponsorList"),
  },
  feeRules: {
    fetchRules: (campaignId) =>
      setBaseUrlPrefix(`/admin/campaigns/${campaignId}/fee-rules`),

    addRule: (campaignId) =>
      setBaseUrlPrefix(`/admin/campaigns/${campaignId}/fee-rules`),

    updateRule: (campaignId, ruleId) =>
      setBaseUrlPrefix(`/admin/campaigns/${campaignId}/fee-rules/${ruleId}`),
  },
  formBuilder: {
    createForm: setBaseUrlPrefix("/form/create"),
    updateForm: setBaseUrlPrefix("/form/update"),
    getForm: setBaseUrlPrefix("/form/get"),
    submitPrereg: setBaseUrlPrefix("/prereg"),
    getResponses: setBaseUrlPrefix("/form/responses"),
  },
  preregistration: {
    initiatePreregistration: (contentType, contentId) => setBaseUrlPrefix(`/prereg/${contentType}/${contentId}/initiate`),
    submitPreregistration: (contentType, contentId) => setBaseUrlPrefix(`/prereg/${contentType}/${contentId}/submit`),
    resendPreregOtp: (contentType, contentId) => setBaseUrlPrefix(`/prereg/${contentType}/${contentId}/resend-otp`),
    sendOtp: (contentType, contentId) => setBaseUrlPrefix(`/prereg/${contentType}/${contentId}/send-otp`),
    unlockTickets: (contentType, contentId) => setBaseUrlPrefix(`/prereg/${contentType}/${contentId}/unlock`),
  },
};

export default apiPathConstants;
